import type { ComponentPublicInstance } from 'vue'

export const isVueComponent = (
  value: unknown,
): value is ComponentPublicInstance =>
  !!value && typeof value === 'object' && '$el' in value
